import { CustomerPdMapper } from 'src/data/customers/CustomerPdMapper'
import { CustomerRxMapper } from 'src/data/customers/CustomerRxMapper'

import { PrivateAppAPI } from '../common/PrivateAppAPI'

import { CustomerMapper } from './CustomerMapper'
import {
  CustomerAPI,
  CustomerLoyaltyAPI,
  CustomerLoyaltyModel,
  CustomerModel,
  CustomerPdAPI,
  CustomerPdModel,
  CustomerRxAPI,
  CustomerRxModel,
  PostCustomerPdData,
  PostCustomerRxData,
  PostSetPasswordData,
  PostTranscribeCustomerRxData,
} from './type'
import { PersistService } from '../common/PersistService'
import { CustomerLoyaltyMapper } from './CustomerLoyaltyMapper'
import { APIResponse } from '../common/type'

export class CustomersService {
  static getCustomer(email: string, customer_hmac?: string | null, customer_guid?: string | null): Promise<CustomerModel> {
    const promise = PrivateAppAPI.request({
      url: `/customers/${customer_guid ?? PersistService.fetch('customer_guid')}`,
      method: 'GET',
      params: {
        id: customer_guid ?? PersistService.fetch('customer_guid'),
        customer_hmac: customer_hmac ?? PersistService.fetch('customer_hmac'),
        email: email ?? PersistService.fetch('customer_email'),
        source: 'myaccount',
      },
    }).then((response: CustomerAPI) =>{
      return new CustomerMapper().getMappedObject({
        from: 'api',
        data: response,
      })
    })
    return promise
  }

  static patchCustomer(
    customerId: string | number,
    data: Record<string, any>,
    params?: { [key: string]: any }
  ): Promise<CustomerModel> {
    const promise = PrivateAppAPI.request({
      url: `/customers/${customerId}`,
      method: 'PATCH',
      data,
      params,
    }).then((response: CustomerAPI) =>
      new CustomerMapper().getMappedObject({
        from: 'api',
        data: response,
      })
    )
    return promise
  }

  static postForgotPassword(
    customerId: string | number,
    data: Record<string, any>
  ): Promise<boolean> {
    const promise = PrivateAppAPI.request({
      url: `/customers/${customerId}/forgot-password`,
      method: 'POST',
      data,
    }).then((response: boolean) => response)
    return promise
  }

  static postResetForgotPassword(
    customerId: string | number,
    data: PostSetPasswordData
  ): Promise<CustomerModel> {
    const promise = PrivateAppAPI.request({
      url: `/customers/${customerId}/reset-forgot-password`,
      method: 'POST',
      data,
    }).then((response: CustomerAPI) =>
      new CustomerMapper().getMappedObject({ from: 'api', data: response })
    )
    return promise
  }

  static postCustomerRx(
    customerId: number,
    creationData: PostCustomerRxData,
    params?: { [key: string]: any }
  ): Promise<CustomerRxModel> {
    const promise = PrivateAppAPI.request({
      url: `/customers/${customerId}/rxs-no-file`,
      method: 'POST',
      data: creationData,
      params: {
        order_based: false,
        create_rx_on_previous_orders: true,
        ...params,
      },
    }).then((response: CustomerRxAPI) =>
      new CustomerRxMapper().getMappedObject({
        from: 'api',
        data: response,
      })
    )
    return promise
  }

  static async postTranscribeCustomerRx(
    customerRxId: number,
    data: PostTranscribeCustomerRxData,
    params?: { [key: string]: any }
  ): Promise<CustomerRxModel> {
    const response = await PrivateAppAPI.request({
      url: `customers/${customerRxId}/rxs/${customerRxId}/transcribe`,
      method: 'POST',
      data,
      params
    })
    return new CustomerRxMapper().getMappedObject({
      from: 'api',
      data: response,
    })
  }

  static postCustomerPd(
    customerId: number,
    creationData: PostCustomerPdData
  ): Promise<CustomerPdModel> {
    const promise = PrivateAppAPI.request({
      url: `/customers/${customerId}/pds-no-file`,
      method: 'POST',
      data: creationData,
      params: {
        order_based: false,
        create_pd_on_previous_orders: true,
      },
    }).then((response: CustomerPdAPI) =>
      new CustomerPdMapper().getMappedObject({
        from: 'api',
        data: response,
      })
    )
    return promise
  }

  static getCustomerLoyaltyStatus(email: string, customer_hmac?: string | null, customer_guid?: string | null): Promise<CustomerLoyaltyModel> {
    const promise = PrivateAppAPI.request({
      url: `/customers/${email}/loyalty`,
      method: 'GET',
      params: {
        id: customer_guid ?? PersistService.fetch('customer_guid'),
        customer_hmac: customer_hmac ?? PersistService.fetch('customer_hmac'),
        email: email ?? PersistService.fetch('customer_email'),
        source: 'myaccount',
      },
    }).then((response: CustomerLoyaltyAPI) =>{
      return new CustomerLoyaltyMapper().getMappedObject({
        from: 'api',
        data: response,
      })
    })
    return promise
  }

  static loginToEthos(email: string, customer_hmac?: string | null, customer_guid?: string | null): Promise<boolean> {
    const promise = PrivateAppAPI.request({
      url: `customers/${email}/login-to-ethos`,
      method: 'POST',
      params: {
        id: customer_guid ?? PersistService.fetch('customer_guid'),
        customer_hmac: customer_hmac ?? PersistService.fetch('customer_hmac'),
        email: email ?? PersistService.fetch('customer_email'),
        source: 'myaccount',
      },
    }).then((response: APIResponse) =>{
      return response.success
    })
    return promise
  }


}
